<script>
import CardExerciseRest from '@components/cards/card-exercise-rest.vue';
import VideoBackgroundPlayer from '@components/video/video-background-player.vue';
import VideoBackgroundPlayerContent from '@/src/components/video/video-background-player-content.vue';
import { breakpointsMixin } from '@mixins/breakpointsMixin';
import { videoComputed, videoMethods, workoutComputed, workoutMethods } from '@state/helpers';

export default {
  mixins: [breakpointsMixin],
  components: {
    CardExerciseRest,
    VideoBackgroundPlayer,
    VideoBackgroundPlayerContent,
  },
  props: {
    workout: {
      type: Object,
      required: true,
      default: () => {},
    },
  },
  data() {
    return {
      setAutoplay: false,
      timerWidth: 0,
      poster: '',
    };
  },
  computed: {
    ...videoComputed,
    ...workoutComputed,
    videoUrl() {
      return (
        this.currentExercise &&
        this.currentExercise &&
        this.currentExercise.mediaAssets &&
        this.currentExercise.mediaAssets.coverVideo &&
        this.currentExercise.mediaAssets.coverVideo.url
      );
    },
    coverPhotoUrl() {
      return (
        this.currentExercise &&
        this.currentExercise &&
        this.currentExercise.mediaAssets &&
        this.currentExercise.mediaAssets.coverPhoto &&
        this.currentExercise.mediaAssets.coverPhoto.url
      );
    },
    autoplay() {
      return !this.isTransitionPeriod && !this.showCircuitIntro;
    },
    hasTabataFitnessType() {
      if (this.currentCircuit.fitness_types) {
        return this.currentCircuit.fitness_types.filter((e) => e.label.toLowerCase() === 'tabata').length > 0;
      } else {
        return false;
      }
    },
    isTabata() {
      if (this.hasTabataFitnessType) {
        return this.currentCircuit.tabata || this.hasTabataFitnessType;
      } else {
        return this.currentCircuit.tabata;
      }
    },
  },
  mounted() {
    this.detailsWidth();
    window.addEventListener('resize', this.detailsWidth);
  },
  destroyed() {
    window.removeEventListener('resize', this.detailsWidth);
  },
  methods: {
    ...videoMethods,
    ...workoutMethods,
    detailsWidth() {
      const detailsSection = document.getElementsByClassName('details-section')[0];
      if (detailsSection) {
        const detailsWidth = detailsSection.clientWidth;

        if (detailsWidth < 350) {
          this.timerWidth = 130;
        }
        if (detailsWidth > 350) {
          this.timerWidth = Math.round(detailsWidth / 2.5);
        }
        if (detailsWidth > 420) {
          this.timerWidth = Math.round(detailsWidth / 3);
        }
        if (detailsWidth > 520) {
          this.timerWidth = Math.round(detailsWidth / 3.8);
        }
      }
    },
  },
  watch: {
    showCircuitIntro(newVal, oldVal) {
      this.poster = newVal ? this.coverPhotoUrl : '';
      this.setAutoplay = !newVal;
    },
  },
};
</script>

<template>
  <div class="container" :class="[{ 'tabata-circuit': isTabata }]">
    <div class="rest-wrapper" v-if="isTransitionPeriod && $_isDesktopView()">
      <CardExerciseRest :restType="restType" :width="timerWidth" />
    </div>

    <VideoBackgroundPlayerContent :videoUrl="videoUrl" :workout="workout" />
    <VideoBackgroundPlayer
      :videoUrl="videoUrl"
      :coverPhotoUrl="coverPhotoUrl"
      :setAutoplay="autoplay"
      v-if="videoUrl"
      :key="videoUrl"
    />
  </div>
</template>

<style lang="scss" scoped>
@import '@design';
// stylelint-disable selector-pseudo-element-no-unknown

.container {
  height: 100vh;
  margin: 0 auto;
  max-width: 100%;
  min-width: $size-content-width-min;
  overflow: hidden;
  padding-left: unset;
  padding-right: unset;
  position: relative;

  ::v-deep .video-wrapper {
    height: 54vh;

    @include media('xxl', null) {
      height: 100vh;
    }
  }

  .rest-wrapper {
    background: rgba(#1c1c1c, 0.8);
    border-top-left-radius: 3.2rem;
    border-top-right-radius: 3.2rem;
    margin-top: auto;
    min-height: 75vh;
    padding-bottom: 2rem;
    padding-top: 2rem;
    position: absolute;
    width: 100%;
    z-index: 2;

    @include media('xxl', null) {
      border-radius: 3.2rem;
      bottom: 0;
      left: 0;
      margin: auto auto 2.5%;
      min-height: 18rem;
      padding-bottom: 2rem;
      padding-top: 2rem;
      position: absolute;
      right: 0;
      width: 60%;
    }
  }
  &.tabata-circuit {
    .rest-wrapper {
      background: #e12128;
    }
  }
  .exercise-drawer-container {
    &.mobile {
      &.inactive {
        background: #07b903;
      }
    }
  }
}
</style>
